// `installation.permissions_changed` (plan 101 slice 03 door 3, #7298): the App
// permission map stored on an installation moved. Its own module beside
// `./maintenance-tenancy.ts`, which is at the file-size bound and only lists it.
//
// `output.before` / `output.after` are the two maps verbatim; the line names the
// move, the maps stay on the row (a permission slug is not a sentence a locale owns).
// Gated on `installationId` like `installation.linked`, and anchored on the account
// the writer named — the `repo_ci_gate` rung reads this column, so the row is the
// account's to see.

import type { TerminalRenderContext, TerminalRendered } from '../../../wire/terminal';
import { num, str } from './maintenance-payload';

export function renderInstallationPermissionsChanged(
  ctx: TerminalRenderContext,
): TerminalRendered | null {
  const { row } = ctx;
  const asNumber = num(row.input, 'installationId');
  const installationId =
    str(row.input, 'installationId') ?? (asNumber === null ? null : String(asNumber));
  if (installationId === null) return null;
  const accountId = str(row.input, 'accountId');
  return {
    line: { key: 'terminal.installation.permissions_changed', params: {} },
    subject:
      accountId !== null
        ? { kind: 'account', id: accountId, label: accountId }
        : { kind: 'session', id: row.sessionId, label: `installation ${installationId}` },
    refs: {},
  };
}
